// applicationContext.js

class ApplicationContext {
    static getId() {
        return localStorage.getItem('id');
    }

    static setId(newId) {
        localStorage.setItem('id', newId);
    }

    static removeId() {
        localStorage.removeItem('id');
    }

    static isIdPresent() {
        return sessionStorage.getItem('id') !== null;
    }
}

export default ApplicationContext;